import React, { useState, useEffect } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import Select from "react-select";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
// import { deleteAndRestoreProduct } from "../reduxSaga/actions";
import { Alert, Snackbar } from "@mui/material";
import { Modal, Button } from "react-bootstrap";
import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import SocieteAndUserService from "../../../services/societeAndUser";
import UtilsUrl from "../../../utils/UtilsUrl";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import ZoneService from "../../../services/Zone";
import toastr from "toastr";
function transformZones(data) {
  if (!data || !Array.isArray(data.success)) {
    throw new Error("Invalid input data");
  }

  return data.success.map((zone) => ({
    value: zone.id,
    label: ` ${zone.name}`,
  }));
}
const ClientSocieteTable = ({ listClients, typeClient, tag }) => {

  const navigate = useNavigate();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [clients, setClients] = useState(listClients);
  // State for selected days
  const [selectedDays, setSelectedDays] = useState([]);

  // Handle day selection
  const handleDaySelection = (day) => {
    setSelectedDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };
  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [zones, setZones] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);
  const [idUser, setIdUser] = useState([]);
  const [existZone, setExistZone] = useState(null);


  const [modalVisible, setModalVisible] = useState(false);
  const [modalDateVisible, setModalDateVisible] = useState(false);
  const { SearchBar } = Search;
  const handleModalClose = () => {
    setModalVisible(false)
    setExistZone(null)
    setSelectedZones([])

  };
  const handleModalShow = () => setModalVisible(true);
  const handleDateModalClose = () => setModalDateVisible(false);
  const handleDateModalShow = () => setModalDateVisible(true);
  const handleZoneSelection = (selectedIds) => {
    setSelectedZones(selectedIds); // Update state with the selected zone IDs
  };
  useEffect(() => {
    const fetchZone = async () => {
      try {
        const response = await ZoneService.getZonesById(getCurrentUserId());
        const options = transformZones(response.data);
        console.log("options", options);

        setZones(options)
      } catch (error) {
        console.error('Error fetching zone:', error);
      }
    };

    fetchZone();
  }, []);

  const handleSaveSelection = () => {
    console.log("Selected Zones:", selectedZones);
    handleModalClose();
  };
  const handleSaveEnregistrer = async () => {
    console.log("Selected Zones:", selectedZones);
    const data = {
      idSociete: idUser,
      idUser: getCurrentUserId(),
      listZones: selectedZones
    }
    try {
      const response = await ZoneService.AffectZonesToSociete(data);
      if (response.status === 200) {
        toastr.success('Zone affected successfully');
        handleModalClose();
      }


    } catch (error) {
      console.error('Error fetching zone:', error);
    }
  };
  const featchZonesBySociete = async () => {
    try {
      const response = await ZoneService.getZonesBySociete(getCurrentUserId(), idUser);
      if (response.status === 200 && response.data.success && response.data.success.length > 0) {
        // console.log(response.data)
        const zoneNames = response.data.success.map(zone => zone.name);

        // Join the names with a comma and space
        const zoneNamesString = zoneNames.join(", ")
        setExistZone(zoneNamesString)
      }


    } catch (error) {
      console.error('Error fetching zone:', error);
    }
  };
  useEffect(() => {
    if (idUser) {
      featchZonesBySociete();
    }
  }, [idUser])
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };

  const onDeleteOrRestaureSociete = (isDeleted, idSociete, index, state) => {
    SocieteAndUserService.deleteAndRestaureSociete(idSociete, isDeleted)
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          window.location.href = "/tiers";
        } else if (Object.keys(response.data)[0] === "error") {
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });

    console.log("index", index);
  };
  const onChangeSociete = (idSociete, state) => {
    SocieteAndUserService.changerTypeClientSociete(
      getCurrentUserId(),
      idSociete,
      state
    )
      .then((response) => {
        console.log("response", response);
        if (response.data.Societe) {
          window.location.href = "/tiers";
        } else if (response.data.error) {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : " + response.data.error);
        }
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : " + e);
      });
  };
  function buttonDeleteFormatter(cell, row) {
    if (row.isDeleted === 0) {
      return (
        <span>
          <button
            className="btn btn-danger"
            onClick={(e) => {
              onDeleteOrRestaureSociete(row.isDeleted, row.id, "allSuplliers");
              setOpenInfoAlert(true);

              setInfoAlertText("Element supprimé avec succée ");

              setClients(clients.filter((dept) => dept.id !== cell));
            }}
          >
            <h6>
              <small>
                {" "}
                <i class="fas fa-trash"></i>
              </small>
            </h6>
          </button>
        </span>
      );
    } else if (row.isDeleted === 1) {
      return (
        <span>
          <button
            className="btn btn-info"
            onClick={(e) => {
              let deletedAndRestoreModel;

              deletedAndRestoreModel = {
                idProduct: cell,
                isDeleted: 0,
              };

              //   dispatch(deleteAndRestoreProduct(deletedAndRestoreModel));
              onDeleteOrRestaureSociete(row.isDeleted, row.id, "allSuplliers");

              setInfoAlertText("Element restauré avec succée ");
              setOpenInfoAlert(true);
              setClients(clients.filter((dept) => dept.id !== cell));
            }}
          >
            <h6>
              <small>
                <RestoreFromTrashRoundedIcon />
              </small>
            </h6>
          </button>
        </span>
      );
    }
  }
  function buttonContactFormatter(cell, row) {
    return (
      <span>
        <button
          className="btn btn-dark"
          onClick={(e) => {
            sessionStorage.setItem("SocieteContactId", row.id);
            navigate("/contacttiers");
          }}
        >
          <h6>
            <small>
              <i class="fas fa-user"></i>
            </small>
          </h6>
        </button>
      </span>
    );

  }
  function buttonClientFournisseurFormatter(cell, row) {
    console.log("row", row);
    if (tag === "FOURNISSEUR") {
      if (row.isDeleted === 0) {
        return (
          <span>
            <button
              key={row.id}
              className="btn btn-danger"
              onClick={(e) => {
                onChangeSociete(row.id, tag);
                // setOpenInfoAlert(true);
                // setInfoAlertText("Fournisseur modifié avec succée ");

                // setClients(clients.filter((dept) => dept.id !== cell));
              }}
            >
              <h6>
                <small>CLIENT</small>
              </h6>
            </button>
          </span>
        );
      } else if (row.isDeleted === 1) {
        return (
          <span>
            {/* <button
            className="btn btn-info"
            onClick={(e) => {
              let deletedAndRestoreModel;

              deletedAndRestoreModel = {
                idProduct: cell,
                isDeleted: 0,
              };

              //   dispatch(deleteAndRestoreProduct(deletedAndRestoreModel));
              onDeleteOrRestaureSociete(row.isDeleted, row.id, "allSuplliers");

              setInfoAlertText("Element restauré avec succée ");
              setOpenInfoAlert(true);
              setClients(clients.filter((dept) => dept.id !== cell));
            }}
          >
            <h6>
              <small>
                 CLIENT
              </small>
            </h6>
          </button> */}
          </span>
        );
      }
    } else if (tag === "CLIENT") {
      if (row.isDeleted === 0) {
        return (
          <span>
            <button
              key={row.id}
              className="btn btn-danger"
              onClick={(e) => {
                onChangeSociete(row.id, tag);
                // setOpenInfoAlert(true);

                // setInfoAlertText("Client modifié avec succée ");

                // setClients(clients.filter((dept) => dept.id !== cell));
              }}
            >
              <h6>
                <small>FOURNISSEUR</small>
              </h6>
            </button>
          </span>
        );
      } else if (row.isDeleted === 1) {
        return (
          <span>
            {/* <button
            className="btn btn-info"
            onClick={(e) => {
              let deletedAndRestoreModel;

              deletedAndRestoreModel = {
                idProduct: cell,
                isDeleted: 0,
              };

              //   dispatch(deleteAndRestoreProduct(deletedAndRestoreModel));
              onDeleteOrRestaureSociete(row.isDeleted, row.id, "allSuplliers");

              setInfoAlertText("Element restauré avec succée ");
              setOpenInfoAlert(true);
              setClients(clients.filter((dept) => dept.id !== cell));
            }}
          >
            <h6>
              <small>
                FOURNISSEUR
              </small>
            </h6>
          </button> */}
          </span>
        );
      }
    }
  }
  const buttonClientZoneFormatter = (cell, row) => (
    <button
      key={row.id}
      className="btn btn-danger"
      onClick={() => {
        setIdUser(row.id)
        handleModalShow();

        // console.log("------------------------------------------------->", row.id)
      }}
    >
      <h6>
        <small>ZONE</small>
      </h6>
    </button>
  );
  const buttonClientJourFormatter = (cell, row) => (
    <button
      key={row.id}
      className="btn btn-danger"
      onClick={() => {
        handleDateModalShow();
      }}
    >
      <h6>
        <small> COMMANDE</small>
      </h6>
    </button>
  );
  function buttonUpdateFormatter(cell, row) {
    if (row.isDeleted === 0) {
      return (
        <span>
          <button
            className="btn btn-dark"
            onClick={(e) => {
              localStorage.setItem("SocieteContactId", row.id);
              navigate("/modifiertiers");
            }}
          >
            <h6>
              <small>
                {" "}
                <i class="fas fa-edit"></i>
              </small>
            </h6>
          </button>
        </span>
      );
    } else if (row.isDeleted === 1) {
      return (
        <button
          className="btn btn-dark"
          disabled
        // onClick={(e) => {
        //   localStorage.setItem("SocieteId", row.id);
        //   navigate("/modifiertiers");
        // }}
        >
          <h6>
            <small>
              {" "}
              <i class="fas fa-edit"></i>
            </small>
          </h6>
        </button>
      );
    }
  }
  function logoFormatter(cell, row) {
    return (
      <span>
        <img
          alt="Remy Sharp"
          src={UtilsUrl.fileRetailURL() + row.fileUrl}
          // ref={(ref) => {
          //   myRefs.current[index] = ref;
          // }}
          class="rounded-circle"
          style={{ width: "50px", height: "50px" }}
        ></img>
      </span>
    );
  }

  const columns = [
    {
      dataField: "id",
      text: "",
      formatter: logoFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "title",
      text: "Raison social",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "matricule",
      text: "Matricule",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "email",
      text: "Email",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "25%" };
      },
    },
    {
      dataField: "numPhone",
      text: "Num",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "id",
      text: "Rendre",
      formatter: buttonClientFournisseurFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "13%" };
      },
    },
    typeClient === "Clients" && {
      dataField: "id",
      text: "Effectuer une Zone",
      formatter: buttonClientZoneFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "13%" };
      },
    },
    typeClient === "Clients" && {
      dataField: "id",
      text: "Jour de Commande",
      formatter: buttonClientJourFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "13%" };
      },
    },
    {
      dataField: "id",
      text: "Modifier",
      formatter: buttonUpdateFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "9%" };
      },
    },
    {
      dataField: "id",
      text: "Contact",
      formatter: buttonContactFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "id",
      text: "Action",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
  ];

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">{typeClient}</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={clients}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                //   expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
      {/* Modal */}
      {/* Modal */}
      <Modal show={modalVisible} onHide={handleModalClose} centered>
        <Modal.Header>
          <Modal.Title>Les Zones</Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleModalClose}
            style={{ fontSize: "1.5rem", background: "none", border: "none" }}
          >
            ×
          </button>
        </Modal.Header>
        <Modal.Body>
          {/* Zone Selector */}
          {existZone &&
            <section>
              <label>Les zones de la société:</label>
              <p>{existZone}</p>
            </section>}
          <section>
            <label>Choisir une zone:</label>

            <Select
              isMulti
              options={zones.map((zone) => ({
                value: zone.value, // Ensure `value` is unique for each zone
                label: zone.label, // Remove leading/trailing spaces from the label
              }))}
              value={selectedZones.map((zoneId) => {
                const zone = zones.find((z) => z.value === zoneId);
                return zone ? { value: zone.value, label: zone.label } : null;
              }).filter(Boolean)} // Filter out null values to avoid errors
              onChange={(selectedOptions) => {
                const selectedIds = selectedOptions.map((option) => option.value);
                console.log('Selected Zone IDs:', selectedIds); // Log the selected zone IDs
                handleZoneSelection(selectedIds); // Update the parent state with selected IDs
              }}
              className="basic-multi-select"
              classNamePrefix="select"
            />
          </section>



        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSaveEnregistrer}>
            Enregistrer
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={modalDateVisible} onHide={handleDateModalClose} centered>
        <Modal.Header>
          <Modal.Title>Jour de Commande</Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleDateModalClose}
            style={{ fontSize: "1.5rem", background: "none", border: "none" }}
          >
            ×
          </button>
        </Modal.Header>
        <Modal.Body>

          {/* Jour de Commande */}
          <div style={{ marginTop: "20px" }}>

            {["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"].map((day) => (
              <div key={day} style={{ marginBottom: "10px" }}>
                <label>
                  <input
                    type="checkbox"
                    value={day}
                    checked={selectedDays.includes(day)}
                    onChange={(e) => {
                      const day = e.target.value;
                      handleDaySelection(day);
                    }}
                    style={{ marginRight: "10px" }}
                  />
                  {day}
                </label>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSaveSelection}>
            Enregistrer
          </Button>
        </Modal.Footer>
      </Modal>


    </div>
  );
};
export default ClientSocieteTable;
